// @dynamic
/**
 * @dynamic need this because there are static memebers
 */

export class Constants {
  public static readonly REQUIRED: string = 'required';

  public static readonly MIN_LENGTH: string = 'minlength';

  public static readonly MAX_LENGTH: string = 'maxlength';

  public static readonly PATTERN: string = 'pattern';

  public static readonly VALID_USERNAME: string = 'ValidUsername';

  public static readonly PASSWORDS_MATCH: string = 'PasswordsMatch';

}
